export default __webpack_public_path__ + "static/7-f6163fff3f765cf438528eb0227e1ed2.jpg";